import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box } from "@material-ui/core";

import { useSelector } from "react-redux";
import useStyles, {  } from "../Styles";
import { getWindowSize } from "../utils";
import userActions from "../actions";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";

const IrrigationDonut = ({ district_deliveries }) => {
  const [windowSize, setWindowSize] = useState(getWindowSize());
  const classes = useStyles();
  const { isMobile } = useGetViewPortDimensions();
  const { loadWaterDeliveries } = userActions();
  const [options, setOptions] = React.useState(null);
  const componentMount = () => {
    loadWaterDeliveries();
  }
  useEffect(componentMount, []);
  const {
    // irrigation_district_water_deliveries: district_deliveries1,
    irrigation_district_selected,
  } = useSelector((state) => state.technical_view);

  Highcharts.setOptions({
    chart: {
      style: {
        fontFamily: "Arial",
      },
    },
    responsive: {
      rules: [{
          condition: {
              maxWidth: 380,
              maxHeight: 380
          },
      }]
  }
  });

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize(getWindowSize());
    };
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  useEffect(() => {
  const optionsInner =
    Object.keys(district_deliveries).length > 0
      ? {
          chart: {
            type: "pie",
            fontFamily: "Arial",
            plotBackgroundColor: "transparent",
            backgroundColor: "transparent",
            // height:
            //   window.innerHeight -
            //   toolbarHeight -
            //   filterContainerHeight -
            //   chartTitleHeight -
            //   150,
            // height: isMobile ? 500 : 640,
            height: 780,
            width: isMobile ? 380 : 640,
            // height: '120%',
            // ...(isMobile && { width: 380 }),
          },
          title: {
            text: `<p style='font-size: 16px; maxWidth: 150px'>Irrigation District</p><br/>
            <p style='font-size: 16px; maxWidth: 150px'>Total Deliveries:</p><br/><p style='font-size: 17px; font-weight:bold'>${district_deliveries[
              irrigation_district_selected.name
            ].district_total_deliveries.toLocaleString("en-US")} ac-ft</p>`,
            align: "center",
            verticalAlign: "middle",
            style: {
              color: "#000",
              lineHeight: "25px",
              marginBottom: "20px",
            },
            y: isMobile ? -75 : -37,
          },
          series: [
            {
              name: "Irrigation District Water Deliveries",
              innerSize: "70%",
              data: [
                {
                  name: "Golf Courses",
                  y: Math.round(
                    district_deliveries[irrigation_district_selected.name]
                      .golf_courses
                  ),
                  color: "#6AA4DC",
                },
                {
                  name: "Schools & Parks",
                  y: Math.round(
                    district_deliveries[irrigation_district_selected.name]
                      .schools_parks
                  ),
                  color: "#FFB607",
                },
                {
                  name: "HOA & Homeowner Yards",
                  y: Math.round(
                    district_deliveries[irrigation_district_selected.name]
                      .hoa_homeowner_yards
                  ),
                  color: "#DE3E40",
                },
                {
                  name: "Industry & Other Turf",
                  y: Math.round(
                    district_deliveries[irrigation_district_selected.name]
                      .industry_and_turfs
                  ),
                  color: "#43B99E",
                },
                {
                  name: "Agriculture",
                  y: Math.round(
                    district_deliveries[irrigation_district_selected.name]
                      .agriculture
                  ),
                  color: "#D88C31",
                },
                {
                  name: "Municipal Tap Water",
                  y: Math.round(
                    district_deliveries[irrigation_district_selected.name]
                      .municipal_drinking
                  ),
                  color: "#2352D0",
                },
              ],
            },
          ],
          credits: {
            enabled: false,
          },

          plotOptions: {
            pie: {
              dataLabels: {
                enabled: false,
              },
              states: {
                hover: {
                  enabled: false,
                },
                inactive: {
                  opacity: 1,
                },
              },
              borderWidth: 0,
              showInLegend: true,
            },
            series: {
              point: {
                events: {
                  legendItemClick: function () {
                    return false; // <== returning false will cancel the default action
                  },
                },
              },
            },
          },
          tooltip: {
            followPointer: false,
            padding: 8,
            backgroundColor: "#FFF",
            borderRadius: 8,
            outside:true,
            useHTML: true,
            style: {
              color: "#000",
              fontFamily: "'Arial', sans-serif",
              lineHeight: "1.5em",
            },
            formatter() {
              const name = this.point.name;
              const value = this.point.y;
              return `Delivery: <b>${name}</b><br/> Water delivery amount: <b>${value.toLocaleString(
                "en-US"
              )}</b>`;
            },
          },
          legend: {
            itemStyle: {
              color: "#333333",
              fontSize: "16px",
              fontWeight: "normal",
              fontFamily: "Arial",
            },
            align: "center",
            backgroundColor: "#FFFFFF",
            borderColor: "#E0E0E0",
            borderWidth: 1,
            borderRadius: 15,
            layout: "horizontal",
            //   width: "25%",
            padding: 10,
            itemMarginTop: 5,
            itemMarginBottom: 5,
            shadow: {
              offsetX: -1,
              offsetY: 3,
              color: "#00000029",
              width: 4,
            },
            reversed: true,
          },
        }
      : {};
      setOptions(optionsInner);
    }, [district_deliveries, windowSize, isMobile, irrigation_district_selected]);
  //gets windowSize to set width of barchart
  return (
    <Box className={classes.chartContainer}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Box>
  );
};
export default IrrigationDonut;
